<template>
  <el-form
      ref="form"
      :model="form"
      label-width="80px">
    <div class="bid-type">
      动态竞价-只降低
      <div class="bid-type-help">当您的广告转化几率较低，我们将实时降低您的竞价。</div>
    </div>
    <el-form-item
        label="默认竞价"
        prop="defaultBid"
        :rules="[
          { required: true, message: '请输入默认竞价', trigger: ['blur', 'change'] },
          $gjReRule(RE.num(2), '请输入两位小数正数'),
          $gjMinRule(0.02, '应大于等于0.02')
        ]">
      <gj-input
          v-model="form.defaultBid"
          width="150px">
        <template #prepend>{{adStore.SD.currencySymbol}}</template>
      </gj-input>
    </el-form-item>
  </el-form>
</template>

<script>
  import {formMixin, formRuleMixin, formValidatorMixin} from "../../../../../../../../minxins";
  import {adStoreMixin} from "../../../../../common/mixin";

  export default {
    name: "app-bid-picker",
    mixins: [formMixin, adStoreMixin, formValidatorMixin, formRuleMixin],
    created() {},
    data() {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "bid-picker";
  
  .bid-type {
    margin-bottom: 16px;
  }
  
  .bid-type-help {
    margin-left: 0;
  }
</style>
